import React from 'react';
import { useNavigate } from 'react-router-dom';
import { services, steps } from '../data/services';
import { servicePoints } from '../data/pages';
import PageHero from '../components/PageHero';
import SectionHeading from '../components/SectionHeading';
import Reveal from '../components/Reveal';
import Icon from '../components/Icon';
import CTA from '../sections/CTA';

const cardIcons = ['automation', 'layers', 'shield', 'loop'];

export default function ServicesPage() {
  const navigate = useNavigate();
  return (
    <>
      <PageHero
        center
        art="circuit"
        title="Digital Excellence Starts Here"
        text="Delivering custom software, web and mobile platforms, and reliable technology support to accelerate growth and efficiency."
        primary={{ label: 'Get In Touch', onClick: () => navigate('/contact') }}
      />

      {services.map((s, i) => (
        <section key={s.title} className="section">
          <div className="container">
            <SectionHeading row title={s.title} text={s.text} />
            {i % 2 === 0 ? (
              <div className="fgrid">
                {servicePoints[i].map((p, k) => (
                  <Reveal key={p} delay={k * 70}>
                    <article className="card fcard">
                      <Icon name={cardIcons[k % 4]} size={40} />
                      <h3>{p}</h3>
                    </article>
                  </Reveal>
                ))}
              </div>
            ) : (
              <div className="alist">
                <Reveal className="alist__visual">
                  <Icon name={s.icon} size={96} />
                  <span>{String(i + 1).padStart(2, '0')}</span>
                </Reveal>
                <ul>
                  {servicePoints[i].map((p, k) => (
                    <Reveal as="li" key={p} delay={k * 70}>
                      <Icon name="arrow" size={22} />{p}
                    </Reveal>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </section>
      ))}

      <section className="section">
        <div className="container">
          <Reveal><span className="pill">How We Work</span></Reveal>
          <SectionHeading row title="Our Simple Process" text="A streamlined approach that turns ideas into impactful solutions, ensuring efficiency, clarity and success at every step." />
          <div className="grid grid--4">
            {steps.map((s, i) => (
              <Reveal key={s.n} delay={i * 80}>
                <article className="card step">
                  <span className="step__n">{s.n}</span>
                  <h3>{s.title}</h3>
                  <p>{s.text}</p>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTA title="Let's Start Something Great Together" highlight="Great" text="Tell us about your project and we'll show you how we can help." />
    </>
  );
}
